<template>
    <div class="lms__superadmin_users_bulk_actions_add_to_groups_preview">
        <component-list
            ref="componentlist"
            :component-table="LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable"
            :component-table-name="'users-preview'"
            :filter-search-queryable="false"
            :filter-search-by-field="'combined'"
            :filter-select-active="false"
            :get-items-getter="'getLmsSuperadminUsersBulkActionsAddToGroupsUsers'"
            :item-name="['user', 'users']"
            :default-page-size="12"
            :selected="usersCheckedProfileIds"
            @emit-check="handleCheck"
        ></component-list>
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable from '@/components/lms/superadmin/users/bulk/actions/addtogroups/LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable'

export default {
  name: 'lms-superadmin-users-bulk-actions-add-to-groups-preview',
  components: { ComponentList },
  data () {
    return {
      LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable
    }
  },
  computed: {
    usersCheckedProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsAddToGroupsUsersCheckedProfileIds
    }
  },
  methods: {
    handleCheck (data) {
      this.$store.dispatch('lmsSuperadminUsersBulkActionsAddToGroupsSetUsersChecked', data)
    },
    checkIfHasUsersChecked () {
      const usersCheckedProfileIds = this.usersCheckedProfileIds

      if (!usersCheckedProfileIds || !usersCheckedProfileIds.length) {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-add-to-groups-select-users' })
      }
    }
  },
  mounted () {
    this.checkIfHasUsersChecked()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionsaddtogroupspreview.scss";
</style>
